const API_BASE_URL = (import.meta as { env?: { VITE_API_URL?: string } }).env?.VITE_API_URL ?? 'http://localhost:5000/api'

function toWebSocketUrl(baseUrl: string): string {
  if (baseUrl.startsWith('https://')) return baseUrl.replace('https://', 'wss://')
  if (baseUrl.startsWith('http://')) return baseUrl.replace('http://', 'ws://')
  return baseUrl
}

export function getSttWebSocketUrl(sessionId: string, meetingId?: string): string {
  return buildAgendaVoiceSttUrl(sessionId, meetingId)
}

export function buildAgendaVoiceSttUrl(sessionId: string, meetingId?: string): string {
  const wsBase = toWebSocketUrl(API_BASE_URL)
  const url = new URL(`${wsBase}/agendaVoice/stt`)
  if (sessionId) url.searchParams.set('sessionId', sessionId)
  if (meetingId) url.searchParams.set('meetingId', meetingId)
  return url.toString()
}

/** Check if the API server is reachable before opening WebSocket. Returns error message or null if OK. */
export async function checkApiReachable(): Promise<string | null> {
  const healthUrl = `${API_BASE_URL.replace(/\/$/, '')}/health`
  try {
    const res = await fetch(healthUrl, { method: 'GET', mode: 'cors' })
    return res.ok ? null : `Health check returned ${res.status}`
  } catch (err) {
    return (err instanceof Error ? err.message : String(err)) || 'Network error'
  }
}

export const agendaVoiceSttApi = {
  createSocket: (sessionId: string, meetingId?: string) => {
    const url = buildAgendaVoiceSttUrl(sessionId, meetingId)
    console.log('[STT] Connecting to WebSocket:', url)
    return new WebSocket(url)
  },
}
